module.exports = __webpack_public_path__ + "img/p7.e00f35a0.png";